import { useEffect } from 'react';

import { INTENT_DETECTION } from '../../../../common/utils/intent-detection';

/**
 * Dispose intent detection state when QuickFind unmounts.
 */
export const useIntentRouterCleanup = () => {
	useEffect(() => {
		return () => {
			INTENT_DETECTION.dispose();
		};
	}, []);
};
